import React, { useState, useEffect }  from 'react';
import { TextField, Typography, Box, Grid, Divider, Button } from '@mui/material';

const InventorySelector = ({ gameData, userInventory, setUserInventory }) => {
  const grades = ['common', 'uncommon', 'rare', 'epic', 'legendary'];

  // Initialize isVisible state
  const [isVisible, setIsVisible] = useState({});

   
  useEffect(() => {
    const initialVisibility = {};
    gameData.animals.forEach(element => {
      initialVisibility[element.id] = false;
    });
    gameData.seeds.forEach(element => {
      initialVisibility[element.id] = false;
    });
    gameData.beds.forEach(element => {
      initialVisibility[element.id] = true;
    });
    setIsVisible(initialVisibility);
  }, [gameData]);

  const handleInventoryChange = (category, id, grade, value) => {
    const quantity = parseInt(value, 10);
    if (isNaN(quantity) || quantity < 0) return;

    setUserInventory(prevState => ({
      ...prevState,
      [category]: {
        ...prevState[category],
        [id]: {
          ...(prevState[category]?.[id] || {}),
          [grade]: quantity,
        },
      },
    }));
  };

  const handleExpand = (item, button) => {
  setIsVisible(prev => ({
    ...prev,
    [item.id]: !prev[item.id]
  }));
  }

  const renderInputs = (category, items) => (
    
    <Box mb={2}>
      <Typography variant="h6" sx={{ textTransform: 'capitalize' }}>{category}</Typography>
      {items.map(item => (
        <Box key={item.id} sx={{ ml: 2, mb: 2 }}>
          <Typography  sx={{ mb: 2 }}>{item.name} <Button variant="outlined" onClick={(e) => handleExpand(item, e)}>{isVisible[item.id] ? '-' : '+'}</Button></Typography>
          <Grid container spacing={2} style={{ display: isVisible[item.id] ? 'flex' : 'none' }}>
            {grades.map(grade => (
              <Grid item xs={6} sm={4} md={2} key={grade}>
                <TextField
                  label={grade}
                  type="number"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={userInventory[category]?.[item.id]?.[grade] || 0}
                  onChange={(e) => handleInventoryChange(category, item.id, grade, e.target.value)}
                  InputProps={{ inputProps: { min: 0 } }}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      ))}
    </Box>
  );

  return (
    <Box>
      {renderInputs('seeds', gameData.seeds)}
      <Divider sx={{ my: 2 }} />
      {renderInputs('animals', gameData.animals)}
      <Divider sx={{ my: 2 }} />
      {renderInputs('beds', gameData.beds)}
    </Box>
  );
};

export default InventorySelector;